<!-- eslint-disable -->
<template lang="pug">
    list-box
        div(slot="header" )
            | {{ $i18n.t('support.support_conversations_header') }}
            div.support__subheader
                svg-icon.subheader__icon(name="clock-o", size="large")
                .subheader__text
                    | {{ $i18n.t('support.support_conversations_workingTime') }}
                    | {{ $i18n.t('support.support_conversations_helpTime') }}
                    span(v-html="emergencyMessage")
                    span(v-html='FAQmessage')
        cs-button(
            color="blue"
            slot="button"
            @click="displayCreateTicketModal = true"
            v-if="user.type !== 'olympiads-student'"
        )
            | {{ $i18n.t('support.support_createTicket') }}
        .support(slot="preview")
            .messages__menu.messages__menu--large
                a.menu__item(
                    href="javascript://"
                    @click="changeFilter({status: 1})"
                    :class="{'menu__item--current': current === 'active'}"
                )
                    | {{ $i18n.t('support.support_conversations_active') }}
                    | ({{ amountOfActive }})
                a.menu__item(
                    href="javascript://"
                    @click="changeFilter({status: 0})"
                    :class="{'menu__item--current': current === 'resolved'}"
                )
                    | {{ $i18n.t('support.support_conversations_resolved') }}
                    | ({{ amountOfResolved }})
                a.menu__item(
                    href="javascript://"
                    @click="changeFilter({all: true})"
                    :class="{'menu__item--current': current === 'all'}"
                )
                    | {{ $i18n.t('support.support_conversations_all') }}
            .messages__body
                .messages__fields
                    .messages__menu
                        a.menu__item(
                            href="javascript://"
                            @click="changeFilter({status: 1})"
                            :class="{'menu__item--current': current === 'active'}"
                        )
                            | {{ $i18n.t('support.support_conversations_active') }}
                            | ({{ amountOfActive }})
                        a.menu__item(
                            href="javascript://"
                            @click="changeFilter({status: 0})"
                            :class="{'menu__item--current': current === 'resolved'}"
                        )
                            | {{ $i18n.t('support.support_conversations_resolved') }}
                            | ({{ amountOfResolved }})
                        a.menu__item(
                            href="javascript://"
                            @click="changeFilter({all: true})"
                            :class="{'menu__item--current': current === 'all'}"
                        )
                            | {{ $i18n.t('support.support_conversations_all') }}
                    .fields__item
                        .support__status-selector
                            cs-multiselect(
                                :multiple="false"
                                :options="['active', 'resolved', 'all']"
                                @input="handleStatusSelect"
                                :value="current"
                                :custom-label="statusName"
                                :placeholder="statusName(current)"
                                :hide-selected="true"
                            )
                        .support__search-box
                            .support__search-item.support__department(v-if="user.isAgent && user.isSuperadmin")
                                span.support__search-label {{ $i18n.t('support.support_department') }}
                                cs-multiselect.support__selector(
                                    :options="departments",
                                    label="name"
                                    :multiple="false",
                                    :show-labels="false",
                                    :searchable="true",
                                    :allow-empty="true",
                                    :placeholder="departmentsPlaceholder",
                                    v-model="searchDepartment"
                                )
                            .support__search-item
                                span.support__search-label--holder
                                cs-input(
                                    type="text"
                                    :placeholder="$i18n.t('support.support_searchPlaceholder')"
                                    v-model="searchTheme"
                                    @keyup.enter="search"
                                )
                                a(href='javascript://', @click="search")
                                    svg-icon.support__search-icon(name="search" size="large")
                        .support__reset
                            span.support__search-label--holder
                            a.support__reset-button(href="javascript://", @click="resetResults")
                                | {{ $i18n.t('fields.fields_dropParameters') }}
                divider(:margin="'10px auto'")
                template(v-if="!isLoading" )
                    template(v-if="tickets.length > 0")
                        .support__fields
                            cs-checkbox.support__message-status-checkbox(v-model="allChecked")
                            .support__message-statuses
                                a.support__message-status(
                                    v-if="current !== 'all'"
                                    href="javascript://"
                                    @click="updateStatus"
                                )
                                    svg-icon.support__status-icon(name="folder" size="large")
                                    span {{ statusState }}
                                a.support__message-status(
                                    href="javascript://"
                                    @click="deleteChecked"
                                )
                                    svg-icon.support__status-icon(name="trash" size="large")
                                    span {{ $i18n.t('support.support_conversations_delete') }}
                                a.support__message-status(
                                    v-if="user.departments.length && checkedTickets.length < 2 && current !== 'resolved'"
                                    href="javascript://"
                                    @click='changeDepartmentHandler'
                                )
                                    svg-icon.support__status-icon(name="reload" size="large")
                                    span {{ $i18n.t('support.support_change-department') }}
                        divider(:margin="0")
                        .messages
                            div(
                                v-for='ticket in tickets',
                                :key='ticket.id',
                            )
                                .message
                                    cs-checkbox(
                                        :checked="checkedTickets.includes(ticket.id)"
                                        @change="checkTicket(ticket.id, $event)"
                                    )
                                    message(:conversation="ticket", :from-support="true")
                                divider(:margin="0")
                        pagination(
                            :last-page="lastPage"
                            :current-page="currentPage"
                            :total="total"
                            :length="tickets.length"
                            :from="from"
                            :to="to"
                        )
                    .messages__info(v-else)
                        | {{ emptyMessage }}
                cs-loader(v-else="")
            create-ticket-modal(
                v-if='displayCreateTicketModal',
                @close='displayCreateTicketModal = false',
                @send='createTicket'
            )
            change-ticket-department-modal(
                v-if='selectDepartmentModal',
                :department="selectedTicket.department",
                @close='selectDepartmentModal = false',
                @update='changeDepartment'
            )

</template>

<script>
    /*eslint-disable*/
    import TicketApi from '../../../api/communication/ticket';

    import SendTicketMixin from '../../../utils/communication/sendTicketMixin';
    import amountsOfTickets from '../../../utils/communication/amountsOfTickets';
    import handleTicketEvents from "../../../utils/communication/handleTicketEvents";

    import ListBox from '../../lists/ListBox.vue'
    import Pagination from '../../lists/Pagination.vue'
    import Message from '../Message.vue'
    import CreateTicketModal from '../../../modals/CreateTicketModal.vue';
    import ChangeTicketDepartmentModal from "../../../modals/ChangeTicketDepartmentModal.vue";

    import _ from 'lodash';
    import {mapState} from 'vuex';
    import {FAQ_URL, TELEGRAM_URL} from '@/config/urls';

    import linkifyStr from 'linkifyjs/string'

    export default {
        mixins: [SendTicketMixin, amountsOfTickets, handleTicketEvents],
        props: ['status', 'all'],
        data() {
            return {
                tickets: [],
                selectedTicket: null,
                lastPage: null,
                total: null,
                currentPage: null,
                isLoading: false,
                from: null,
                to: null,
                form: { status: 1 },
                displayCreateTicketModal: false,
                selectDepartmentModal: false,
                checkedTickets: [],
                allChecked: false,
                statusState: this.$i18n.t('support.support_status_resolve'),
                message: '',
                isActive: false,
                current: 'active',
                searchTheme: '',
                searchDepartment: null,
                departments: [],
                page: null,
                isAmountsLoading: false
            };
        },
        components: {
            ListBox,
            CreateTicketModal,
            Message,
            Pagination,
            ChangeTicketDepartmentModal
        },
        watch: {
            '$route': {
                handler(val) {
                    this.page = val.query.page;
                    this.fetchData();
                },
                deep: true,
            },
            allChecked(val) {
                if (val) {
                    this.checkedTickets = this.tickets.map(ticket => ticket.id);
                } else {
                    this.checkedTickets = [];
                }
            },
            current (value) {
                if (value === 'all') {
                    this.statusState = '';
                    return;
                }
                this.statusState = value === 'active'
                        ? this.$i18n.t('support.support_status_resolve')
                        : this.$i18n.t('support.support_status_resume');
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            emptyMessage () {
                switch (this.current) {
                    case 'all':
                        return this.$i18n.t('support.support_noTickets',
                                {ask: !this.user.departments.length ? this.$i18n.t('support.support_suggestionToAsk') : ""}
                        );
                    case 'active':
                        return this.$i18n.t('support.support_noActiveTickets');
                    case 'resolved':
                        return this.$i18n.t('support.support_noResolvedTickets');
                }
            },
            departmentsPlaceholder () {
                return this.$i18n.t('common.common_placeholder_enterToSearch');
            },
            FAQmessage () {
                return linkifyStr(' ' + this.$i18n.t('support.support_conversations_FAQ', { url: FAQ_URL }), {})
            },
            emergencyMessage () {
                return linkifyStr(' ' + this.$i18n.t('support.support_conversations_emergency', { url: TELEGRAM_URL }), {})
            }
        },
        mounted () {
            if (this.status || this.status === 0) {
                this.form = {};
                this.form = { status: this.status };
                this.current = this.status
                        ? 'active'
                        : 'resolved';
            }
            if (this.all) {
                this.form = {};
                this.current = 'all';
            }
            this.departments = this.user.departments.map(department => {
                department.name = this.$i18n.t('support.support_departmentName_' + department.type);
                return department;
            });
            this.fetchData();
        },
        methods: {
            changeFilter (request = {}) {
                this.selectedTicket = null;
                this.checkedTickets = [];
                this.page = null;
                this.searchTheme = '';
                this.$route.query.page = 1;
                this.current = 'all';
                this.isLoading = true;
                this.form = {};
                if (request.all) {
                    this.current = 'all';
                } else if (request.status) {
                    this.current = 'active';
                } else {
                    this.current = 'resolved';
                }
                Object.assign(this.form, request);
                this.isActive = false;
                this.fetchData();
            },
            search () {
                this.searchDepartment && (this.form.department = this.searchDepartment.id);
                this.searchTheme && (this.form.searchTheme = this.searchTheme);
                this.page = 1;
                this.fetchData();
            },
            resetResults() {
                this.searchTheme = '';
                this.searchDepartment = null;
                this.fetchData();
            },
            fetchData () {
                this.isLoading = true;
                if (!this.page) {
                    this.page = this.$route.query.page
                }
                this.form.page = this.page || 1;
                this.searchDepartment && (this.form.department = this.searchDepartment.id);
                this.searchTheme && (this.form.searchTheme = this.searchTheme);
                TicketApi.list(this.form)
                .then(data => {
                    this.tickets = data.data;
                    this.lastPage = data.lastPage;
                    this.total = data.total;
                    this.currentPage = data.currentPage;
                    this.from = data.from;
                    this.to = data.to;
                    if (this.lastPage > 0 && this.currentPage > this.lastPage) {
                        this.currentPage = this.lastPage;
                        this.$route.query.page = this.lastPage;
                        this.page = this.lastPage;
                        this.fetchData();
                    }
                    this.message = '';
                    this.form = {};
                    if (this.current === 'all') {
                        this.form = { all: true };
                    } else if (this.current === 'active') {
                        this.form = { status: 1 };
                    } else {
                        this.form = { status: 0 };
                    }
                    this.isLoading = false;
                })
                .catch(error => {
                    this.form = {};
                    this.isLoading = false;
                    this.$toasted.error(this.$root.$t('errors.message_handling'));
                });
            },
            deleteChecked () {
                if (this.checkedTickets.length > 0) {
                    TicketApi.delete(this.checkedTickets[0], { ticketsIds: this.checkedTickets })
                    .then(() => {
                        this.fetchData();
                        this.checkedTickets = [];
                        this.allChecked = false;
                    })
                    .catch(error => {
                        this.$toasted.error(this.$root.$t('errors.message_handling'));
                        this.isLoading = false;
                    });
                }
            },
            changeDepartmentHandler () {
                if (!this.checkedTickets || !this.checkedTickets.length) {
                    return;
                }
                this.selectedTicket = this.tickets.find(ticket => {
                    return ticket.id === this.checkedTickets[0];
                });
                if (!this.isUserAbleToChangeDepartment()) {
                    this.$toasted.error(this.$root.$t('errors.support_ticketUpdate_noAccessToDepartment'));
                    return;
                }
                this.selectDepartmentModal = true;
            },
            changeDepartment (departmentId) {
                this.isLoading = true;
                TicketApi.update(this.selectedTicket.id, {departmentId: departmentId})
                .then((ticket) => {
                    let departmentsIds = this.user.departments.map(department => department.id);
                    if (!departmentsIds.includes(ticket.departmentId)) {
                        this.tickets = this.tickets.filter(item => item.id !== ticket.id)
                    } else {
                        TicketApi.show(ticket.id)
                        .then(ticket => {
                            this.tickets.unshift(ticket);
                            this.tickets = _.uniqBy(this.tickets, 'id');
                        }).catch(() => {
                            this.$toasted.error(this.$root.$t('errors.message_handling'));
                            this.isLoading = false;
                        });
                    }
                    this.isLoading = false;
                }).catch(() => {
                    this.$toasted.error(this.$root.$t('errors.message_handling'));
                    this.isLoading = false;
                });
                this.selectedTicket = null;
                this.checkedTickets = [];
            },
            isUserAbleToChangeDepartment () {
                return this.user.departments.find(department => this.selectedTicket.departmentId === department.id);
            },
            updateStatus () {
                if (!this.checkedTickets || !this.checkedTickets.length) {
                    return;
                }
                this.isLoading = true;
                let status = this.statusState === this.$i18n.t('support.support_status_resolve') ? 0 : 1;
                let form = {
                    ticketsIds: this.checkedTickets,
                    status: status
                };
                TicketApi.updateSome(form)
                .then(() => {
                    if (this.checkedTickets.length !== 0) {
                        this.form.status = status ? 0 : 1;
                        this.fetchData();
                    }
                    this.checkedTickets = [];
                    this.allChecked = false;
                })
                .catch(error => {
                    this.$toasted.error(this.$root.$t('errors.message_handling'));
                    this.isLoading = false;
                });
            },
            handleStatusSelect (selector) {
                switch (selector) {
                    case 'active':
                        this.changeFilter({status: 1});
                        break
                    case 'resolved':
                        this.changeFilter({status: 0});
                        break
                    case 'all':
                        this.changeFilter({status: true});
                        break
                }
            },
            statusName (status) {
                status = status.replace('support.support_conversations_', '');
                return this.$i18n.t('support.support_conversations_' + status);
            },
            checkTicket (ticketId, input) {
                input
                        ? this.checkedTickets.push(ticketId)
                        : (this.checkedTickets = this.checkedTickets.filter(id => id !== ticketId))
            }
        },
    }
</script>

<style lang="scss" scoped>
    .support {
        display: flex;
    }

    .support__subheader {
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
        margin-top: 5px;
        display: flex;
        align-items: center;
    }

    .subheader__icon {
        margin-right: 10px;
    }

    .messages__menu {
        display: none;
        @include media($xlg) {
            display: flex;
            flex-direction: column;

            font-size: 18px;
            line-height: 42px;

            min-width: 140px;
            margin-right: 30px;
        }
        @include media($xl) {
            display: none;
        }
    }

    .messages__menu--large {
        display: none;
        @include media($xl) {
            display: flex;
        }
    }

    .menu__item {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .menu__item--current {
        color: $x-color-black;
        text-decoration: none;
        &:hover {
            color: $x-color-black;
            text-decoration: none;
        }
    }

    .messages__body {
        padding: 0;
        width: 100%;
    }

    .messages__fields {
        display: flex;
        flex: 1 1 auto;
    }

    .fields__item {
        width: 100%;
    }

    .support__status-selector {
        display: flex;
        @include media($xlg) {
            display: none;
        }
    }


    .support__search-box {
        display: flex;
        margin: 15px 0;
        flex-direction: column;
        @include media($xlg) {
            margin: 0 0 15px;
        }
        @include media($xl) {
            flex-direction: row;
            margin: 15px 0;
        }
    }

    .support__search-box .cs-input {
        margin: 0;
    }

    .support__search-item {
        display: flex;
        align-items: center;
        width: 100%;
    }


    .support__department {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @include media($md) {
            flex-direction: row;
            align-items: center;
        }
    }

    .support__search-item:not(:last-child) {
        margin-bottom: 15px;
        @include media($md) {
            margin: 0 0 15px 0;
        }
        @include media($xl) {
            margin: 0 20px 0 0;
        }
    }

    .support__search-label {
        font-size: 16px;
        line-height: 19px;
        color: $x-color-full-black;

        margin-bottom: 15px;
        @include media($md) {
            margin: 0 20px 0 0;
        }
        @include media($xlg) {
            min-width: 3em;
        }
        @include media($xl) {
            min-width: 0;
        }
    }

    .support__search-label--holder {
        @include media($xlg) {
            min-width: calc(3em + 20px);
        }
        @include media($xl) {
            min-width: 0;
        }
    }

    .support__search-icon {
        color: $hsl-color-blue-56;
        margin-left: 10px;
    }

    .support__reset {
        display: flex;
        align-items: center;
        width: 100%;
        margin: 20px 0 30px;
    }

    .support__reset-button {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .support__fields {
        display: flex;
        padding: 0;
        margin: 30px 0;
    }

    .support__message-statuses {
        display: flex;
        flex-direction: column;
        @include media($xlg) {
            width: 100%;
            flex-direction: row;
            justify-content: space-between;
        }
    }

    .support__message-status-checkbox {
        margin: 0 20px 0 0;
    }

    .support__message-status {
        margin-bottom: 25px;
        display: flex;
        align-items: center;
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
        &:last-child {
            margin: 0;
        }
        @include media($xlg) {
            margin: 0;
        }
    }

    .support__status-icon {
        margin-right: 10px;
    }

    .message {
        display: flex;
        align-items: center;
        margin-bottom: 0;
        background-color: transparent;
        border-radius: 0;
        font-size: medium;
        &:hover {
            background-color: $hsl-color-gray-96;
        }
    }

    .messages__info {
        margin-top: 30px;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
    }
</style>
